module.exports = __webpack_public_path__ + "1db9670409e5b2e71eb1d2c61fd0744f.pdf";